var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"list__item"},[_c('p',[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }